import { render, staticRenderFns } from "./DeviceTabs.vue?vue&type=template&id=26ab86b3&scoped=true&"
import script from "./DeviceTabs.vue?vue&type=script&lang=js&"
export * from "./DeviceTabs.vue?vue&type=script&lang=js&"
import style0 from "./DeviceTabs.vue?vue&type=style&index=0&id=26ab86b3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26ab86b3",
  null
  
)

export default component.exports